(function() {
  // Brand to collection ID mapping
  const brandCollectionMap = {
    'kars-nuts': '[COLLECTION_ID]', // Replace with actual collection ID
    'sanders': '[COLLECTION_ID]',   // Replace with actual collection ID
    'sahale': '[COLLECTION_ID]',    // Replace with actual collection ID
    'brownie-brittle': '[COLLECTION_ID]', // Replace with actual collection ID
    'voortmans': '[COLLECTION_ID]', // Replace with actual collection ID
  };

  // Add collection context to search forms
  function addCollectionContextToSearch() {
    // Get current path to check if we're on a brand page
    const path = window.location.pathname;
    const brandMatch = path.match(/\/pages\/([^\/]+)/);
    
    if (brandMatch) {
      const brandName = brandMatch[1];
      const collectionId = brandCollectionMap[brandName];
      
      if (collectionId) {
        // Find all search forms and add the collection context
        document.querySelectorAll('form[action="/search"]').forEach(form => {
          // Don't modify forms that already have collection context
          if (!form.querySelector('input[name="collection_scope"]')) {
            const collectionInput = document.createElement('input');
            collectionInput.type = 'hidden';
            collectionInput.name = 'collection_scope';
            collectionInput.value = collectionId;
            form.appendChild(collectionInput);
            
            // Add boost context for Search & Discovery
            const boostInput = document.createElement('input');
            boostInput.type = 'hidden';
            boostInput.name = 'boost_context';
            boostInput.value = 'collection_' + collectionId;
            form.appendChild(boostInput);
          }
        });
      }
    }
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    addCollectionContextToSearch();
  });
})();